var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"\n    text-white text-[12px]\n    leading-[21px]\n    py-1\n    px-3\n    rounded-full\n    mr-2\n    inline-block\n  ",class:_vm.type},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }